import { StationaryBookingNextStepsFromStore } from '@components/BookingFlow/Stationary/StationaryBookingNextSteps';
import { ContentWrapperCustomerApp } from '@components/Layouts/ContentWrapperCustomerApp';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { NoddiLink } from 'noddi-ui-web';
import { useCurrentBrand } from '../../../../stores/BrandStore/brandStore';
import { useStationaryBookingActions } from '../../../../stores/StationaryBookingStore';

export const StationaryBookingConfirmationNoPayment = () => {
  const { brandUrl } = useCurrentBrand();
  const { clearStore } = useStationaryBookingActions();

  return (
    <ContentWrapperCustomerApp hideBackButton>
      <div className='flex flex-col gap-4'>
        {/* eslint-disable-next-line noddi/no-emoji-in-ui -- deliberate emoji in customer-facing copy: it carries the tone of the message, it is not a status a NoddiIcon could show */}
        <p className='text-3xl font-bold text-primary md:text-4xl'>{t`Booking confirmed`} 🚀</p>

        <StationaryBookingNextStepsFromStore />
        <NoddiLink to={brandUrl} className='w-full' onClick={clearStore}>
          <Trans>Close</Trans>
        </NoddiLink>
      </div>
    </ContentWrapperCustomerApp>
  );
};
